import VueRouter from "vue-router";
import urls from "../urls";
import heatRoutes from "heat-shared/src/routes";
import {firstTimeGuard, permissionsGuard} from "./guards";
import Vue from "vue";
import HomePage from "../pages/HomePage";
import ProfilePage from "../pages/ProfilePage";
import ListFiles from "../pages/ListFiles";
import ListReports from "../pages/ListReports";
import CsvViewer from "../pages/CsvViewer";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomePage,
        },
        {
            path: '/account/',
            name: 'user-profile',
            component: ProfilePage,
            meta: {
                permission: 'user',
            },
        },
        {
            path: '/files/',
            name: 'list-files',
            component: ListFiles,
            meta: {
                permission: 'user',
            },
        },
        {
            path: '/reports/',
            name: 'list-reports',
            component: ListReports,
            meta: {
                permission: 'user',
            },
        },
        {
            path: '/reports/:fileId',
            name: 'csv-viewer',
            component: CsvViewer,
            props: true,
            meta: {
                permission: 'user',
            },
        },
        {
            path: urls.admin_site,
            name: 'admin-site',
            beforeEnter() {location.href = '/admin/'}
        },
        ...heatRoutes,
    ],
});

router.beforeEach(firstTimeGuard);
router.beforeEach(permissionsGuard);

export default router;
